/*
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/

import { html, Polymer } from '@polymer/polymer/polymer-legacy.js';
/** 
 * This element sets media query properties used in shared-styles. include this element in your components to avoid writing general media queries
 * @customElement
 * @polymer
 * @demo node_modules/speedboat_ui/elements/demo/app-media-query-demo.html
 * @summary Technical component
*/
const template = html`
		<iron-media-query query="(max-width: 479px)" query-matches="{{phone}}"></iron-media-query>
		<iron-media-query query="(min-width: 480px) and (max-width: 839px)" query-matches="{{tablet}}"></iron-media-query>
		<iron-media-query query="(min-width: 840px)" query-matches="{{desktop}}"></iron-media-query>
		<iron-media-query query="(min-width: 1280px)" query-matches="{{largedesktop}}"></iron-media-query>
		<!--Added specifically for corporate tablet handling-->
		<iron-media-query query="(min-width: 640px)" query-matches="{{desktopview}}"></iron-media-query>
		<!--Need to be removed when handling for portrait is done-->
		<iron-media-query query="(min-width: 640px) and (max-width: 839px) and (orientation: portrait)" query-matches="{{notsupporteddevice}}"></iron-media-query>
	`

Polymer({
	is: "app-media-query",
	_template: template,
	properties: {
    /* property to check the device type is phone or not */
		phone: {
			type: Boolean,
			value: false,
			notify: true
		},
    /* property to check the device type is tablet or not */
		tablet: {
			type: Boolean,
			value: false,
			notify: true
		},
    /* property to check the device type is desktop or not */
		desktop: {
			type: Boolean,
			value: false,
			notify: true
		},
    /* property to check the device type is large desktop or not */
		largedesktop: {
			type: Boolean,
			value: false,
			notify: true
		},
    /* property to check the device view */
		desktopview: {
			type: Boolean,
			value: false,
			notify: true,
			observer: '_desktopViewChanged'
		},
		/*Need to be removed when handling for portrait is done*/
		notsupporteddevice: {
			type: Boolean,
			value: false,
			notify: true
		},
    /*TO notify that corporate view is loaded*/
		corporateviewloaded: {
			type: String,
			notify: true
		},
    /* property to check the device is ios or android */
		isiosandroiddevice: {
			type: Boolean,
			value: false,
			notify: true
		}
	},
	attached: function () {
		this._checkifphoneDevice();
	},
	/*Need to be removed when handling for portrait is done*/
	_desktopViewChanged: function () {
		if (this.corporateviewloaded) {
			if (this.corporateviewloaded == 'desktop') {
				if (!this.desktopview)
					this.notsupporteddevice = true;
				else
					this.notsupporteddevice = false;
			}
		}
	},
	/*To hide an element other than desktop*/
	_checkifphoneDevice: function () {
		if (channelType.iphone || channelType.android) {
			this.isiosandroiddevice = true;
		}
		else {
			this.isiosandroiddevice = false;
		}
	}
});
